import { createContext, useContext, useEffect, useState } from "react";

const KEY = "pflegeheim_check_v1";
const CheckContext = createContext(null);

export function CheckProvider({ children }) {
    const [answers, setAnswers] = useState(() => {
        if (typeof window === "undefined") return {};
        try {
            return JSON.parse(localStorage.getItem(KEY) || "{}");
        } catch {
            return {};
        }
    });
    const [teaser, setTeaser] = useState(null);

    useEffect(() => {
        try {
            localStorage.setItem(KEY, JSON.stringify(answers));
        } catch {
            /* ignore */
        }
    }, [answers]);

    const setAnswer = (id, value) => setAnswers((a) => ({ ...a, [id]: value }));
    const reset = () => {
        setAnswers({});
        setTeaser(null);
        try {
            localStorage.removeItem(KEY);
        } catch {
            /* ignore */
        }
    };

    return (
        <CheckContext.Provider value={{ answers, setAnswer, setAnswers, reset, teaser, setTeaser }}>
            {children}
        </CheckContext.Provider>
    );
}

export function useCheck() {
    const ctx = useContext(CheckContext);
    if (!ctx) throw new Error("useCheck must be used inside CheckProvider");
    return ctx;
}
